export function truncateStringValues<T>(value: T, maxLength: number): T {
  if (value == null) {
    return value;
  }

  if (typeof value === 'string') {
    if (value.length <= maxLength) {
      return value;
    }
    return `${value.slice(0, maxLength)} [Truncated]` as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => truncateStringValues(item, maxLength)) as T;
  }

  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [
        k,
        truncateStringValues(v, maxLength),
      ])
    ) as T;
  }

  return value;
}

export function toSafeJson(value: unknown): unknown {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
}

// Some requests return a comma-separated list of request IDs,
// we want to normalize it to a single request ID.
export function normalizeRequestId(requestId: string): string {
  return (
    requestId
      .split(',')
      .map((id) => id.trim())
      .at(0) ?? requestId
  );
}
